import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';
import gql from '@zenbusiness/application-commons-utils/gql';

export const GET_BANKING_APPLICATION = gql`
  query bankingApplication($businessEntityUuid: UUID!) {
    bankingApplication(input: { businessEntityUuid: $businessEntityUuid }) {
      status
      applicationId
      applicationDataId
    }
  }
`;

/**
 * Hook to fetch banking application status
 * @param {boolean} shouldFetch - Whether to fetch the banking application status
 * @returns {object} Banking application data and loading state
 */
function useBankingApplicationStatus(shouldFetch = false) {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, errors } = useQuery(GET_BANKING_APPLICATION, {
    variables: { businessEntityUuid },
    skip: !businessEntityUuid || !shouldFetch,
    noThrow: true
  });

  useError(errors);

  return {
    applicationStatus: data?.bankingApplication?.status,
    applicationId: data?.bankingApplication?.applicationId,
    applicationDataId: data?.bankingApplication?.applicationDataId,
    loading,
    hasError: errors?.length > 0
  };
}

export default useBankingApplicationStatus;
